import React from 'react'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import UserMenu from './UserMenu'
import { Moon, Sun } from 'lucide-react'
import useThemeStore from '../stores/themeStore'
import VideoPlayerModal from './VideoPlayer'
import { useRunningSagaCount } from '../hooks/useActivity'

const navItems = [
  { to: '/research', label: 'Research' },
  { to: '/sources', label: 'Sources' },
  { to: '/overviews', label: 'Overviews' },
  { to: '/activity', label: 'Activity' },
  { to: '/settings', label: 'Settings' },
]

export default function Layout({ children }) {
  const isDark = useThemeStore((s) => s.isDark)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)
  const runningCount = useRunningSagaCount()

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-gold/70 dark:border-gold/40 bg-parchment-50/80 dark:bg-midnight-800/80 backdrop-blur">
        <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
          {/* Wordmark */}
          <div className="flex items-center gap-2.5">
            <span className="inline-block w-2 h-2 rounded-full bg-spark shadow-glow" />
            <span className="font-display text-xl font-semibold tracking-wide text-ink dark:text-gold">
              Veralis
            </span>
            <span className="hidden sm:inline text-[11px] uppercase tracking-[0.18em] text-gold-deep dark:text-gold/70">
              Illuminating&nbsp;Truth
            </span>
          </div>

          <nav className="flex items-center gap-1">
            {navItems.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  clsx(
                    'px-3 py-1.5 rounded-md text-sm font-medium transition',
                    isActive
                      ? 'text-ink dark:text-mist'
                      : 'text-ink-soft hover:text-ink dark:text-mist/60 dark:hover:text-mist'
                  )
                }
              >
                {({ isActive }) => (
                  <span className="relative inline-flex items-center gap-1.5">
                    {label}
                    {to === '/activity' && runningCount > 0 && (
                      <span className="inline-flex items-center justify-center min-w-[1.1rem] h-[1.1rem] px-1 rounded-full text-[10px] font-semibold bg-cyan-500 text-white">
                        {runningCount}
                      </span>
                    )}
                    {isActive && (
                      <span className="absolute -bottom-1 left-0 right-0 h-0.5 rounded-full bg-gradient-to-r from-gold to-spark" />
                    )}
                  </span>
                )}
              </NavLink>
            ))}
            <button
              onClick={toggleTheme}
              aria-label="Toggle theme"
              className="ml-2 p-2 rounded-md text-ink-soft hover:bg-parchment-200 dark:text-mist/70 dark:hover:bg-midnight-700"
            >
              {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            <UserMenu />
          </nav>
        </div>
      </header>

      <main className="flex-1 w-full max-w-5xl mx-auto px-5 py-10 animate-fade-in">{children}</main>

      {/* one player for the whole app — opened via playerStore from any chip */}
      <VideoPlayerModal />
    </div>
  )
}
